import { search } from './searchService';
import { get, getById, put } from './apiService';
import type { CallVoice } from '../types/callVoice';
import type { SearchParams } from '../types/search';
import type { SyncTwilioResult } from './callPhoneNumberService';

export async function getCallVoiceById(id: string, queryParams?: string): Promise<CallVoice> {
  return getById<CallVoice>('/call-voices', id, queryParams);
}

export async function updateCallVoice(id: string, data: CallVoice): Promise<CallVoice> {
  return put<CallVoice>(`/call-voices/${id}`, data);
}

export async function searchCallVoices(
  filter: Record<string, string> = {},
  params: SearchParams = {},
): Promise<CallVoice[]> {
  return search<CallVoice>('/call-voices/search', filter, params);
}

export async function syncRetellActiveVoices(): Promise<SyncTwilioResult> {
  return get<SyncTwilioResult>('/call-voice/retell/active');
}
